import React from "react";
import HomeIcon from "../common/HomeIcon";
import DownloadBtnCommon from "../common/DownloadBtn";
import Mantra_3_A1_Share from "../Mantra3/Mantra_3_A1_Share";
import SharePrintIcon from "../common/SharePrintIcon";
import { imgBaseUrl } from "../../utils/url";

import Mantra_25_New_Edit from "../Mantra25_New/Mantra_25_New_Edit";
import CommonEmailBtn from "../common/EmailBtn";
import Mantra_12_New_Edit from "../Mantra12_New/Mantra_12_New_Edit";
import Loader from "../loader/loader";
import { mailSuccessStore } from "../../config/store";
import Mantra6_3 from "../Mantra6/mantra6_3";
import WallList from "../common/WallList";

class Mantra_FillEmailDownload extends React.Component {
  constructor() {
    super();
    this.state = {
      form: false,
      showCanvas: false,
      img: null,
      id: null,
      bckBttn: false,
      isLoading: false,
      email: "",
    };
  }

  componentDidMount() {
    mailSuccessStore.subscribe(() => {
      let item = mailSuccessStore.getState().data;
      if (item.email) {
        this.setState({ email: item.email });
      }
      if (item.isLoading) {
        this.setState({ isLoading: true });
      } else {
        this.setState({ isLoading: false });
        if (item.showThankYouPopUp) {
          this.setState({ showThankYouPopUp: true });
        }
      }
    });
  }

  setForm = () => {
    this.setState({ form: true, bckBttn: true });
  };

  onCanVase = (img, id) => {
    this.setState({
      showCanvas: true,
      form: false,
      img,
      id,
      random: Math.random(),
    });
  };

  backToForm = () => {
    this.setState({ form: false, bckBttn: false });
  };

  showDownload = () => {
    this.setState({
      showDownloadAndEmail: true,
      form: false,
      random: Math.random(),
    });
  };

  handleLoader = (isLoading) => {
    console.log("isLoading function", isLoading);
    this.setState({ isLoading });
  };

  closeThankYouPopUp = () => {
    this.setState({ showThankYouPopUp: false });
  };

  render() {
    const {
      form,
      img,
      id,
      bckBttn,
      isLoading,
      showThankYouPopUp,
      email,
    } = this.state;

    const { pageData, module_name } = this.props;
    let image = pageData.template_url ? imgBaseUrl + pageData.template_url : "";
    let text = pageData.description ? pageData.description : "";

    let editComponent = null;
    if (module_name == "m25b") {
      editComponent = (
        <Mantra_25_New_Edit {...this.props} onCanVase={this.onCanVase} />
      );
    } else if (module_name == "m12a") {
      editComponent = (
        <Mantra_12_New_Edit {...this.props} onCanVase={this.onCanVase} />
      );
    }

    if (isLoading) {
      return <Loader />;
    }
    if (showThankYouPopUp) {
      return (
        <Mantra6_3 email={email} closeThankYouPopUp={this.closeThankYouPopUp} />
      );
    }

    return (
      <>
        <HomeIcon goToFormBack={bckBttn} backToForm={this.backToForm} />
        {form
          ? editComponent
          : !this.state.showCanvas && (
            <div className="m3_a1_container">
              <SharePrintIcon
                pageData={this.props.pageData}
                image={image}
                text={text}
                id={module_name}
              />
              <div className="container">
                <div className="pos_rel">
                  <img
                    src="/assets/img/mantra_6_icon.png"
                    className="mn6_ic"
                    alt=""
                  />
                  <img src={pageData.template_url} className="m3a1_img" />
                </div>
                <div className="mantra_18_btns">
                  {!this.state.showDownloadAndEmail && (
                    <button
                      className="btn_f"
                      onClick={() => {
                        this.setForm();
                      }}
                    >
                      Fill & Share
                    </button>
                  )}

                  {this.state.showDownloadAndEmail && (
                    <DownloadBtnCommon
                      pageData={pageData}
                      module={module_name}
                    >
                      <button className="btn_f">Download</button>
                    </DownloadBtnCommon>
                  )}

                  <h5 className="or">Or</h5>
                  {this.state.showDownloadAndEmail && (
                    <CommonEmailBtn
                      module_name={module_name}
                      pageData={this.props.pageData}
                      handleLoader={this.handleLoader}
                    >
                      <button type="button" className="btn_f">
                        Email
                        </button>
                    </CommonEmailBtn>
                  )}

                  {!this.state.showDownloadAndEmail && (
                    <button
                      type="button"
                      className="btn_f"
                      onClick={this.showDownload}
                    >
                      Download / Email
                    </button>
                  )}
                </div>
              </div>
            </div>
          )}

        {this.state.showCanvas && img && (
          <Mantra_3_A1_Share img={img} id={id} pageData={this.props.pageData} />
        )}
        
        <WallList module_name={this.props.module_name} type={this.props.type} />
      </>
    );
  }
}

export default Mantra_FillEmailDownload;
